var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramProcess40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Process40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Paper",
    stroke: "#4F4D4C",
    fill: "#FFFFFF",
    x: 11,
    y: 9,
    width: 17,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.7,
    y1: 19.26,
    x2: 24.5,
    y2: 19.26,
    id: "Line",
    stroke: "#4F4D4C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.7,
    y1: 16.56,
    x2: 24.5,
    y2: 16.56,
    id: "Line",
    stroke: "#4F4D4C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.7,
    y1: 13.86,
    x2: 24.5,
    y2: 13.86,
    id: "Line",
    stroke: "#4F4D4C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    cx: 26.2,
    cy: 27.06,
    r: 5.94
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#4F4C4D",
    points: "23.725 27.8640988 25.2578088 29.3969075 28.7397377 24.585"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramProcess40);
export default __webpack_public_path__ + "static/media/pictogramProcess40.e8fadcb7c8e1e69e4edf356495bded3f.svg";
export { ForwardRef as ReactComponent };